// SPDX-License-Identifier: AGPL-3.0-or-later
// Optional grey palette with the existing TCN teal/gold highlights.
export const GREY_THEME_CSS = `/**
 * @name Grey
 * @description Optional grey (#36363e), teal and gold palette for the Dark base theme. Other base themes remain unchanged.
 * @author The Cantina Network
 * @version 1.0.0
 * @tags dark, grey, tcn
 */
/* SPDX-License-Identifier: AGPL-3.0-or-later */

:root.theme-dark {
  --brand-primary: #175251 !important;
  --brand-secondary: #1c6563 !important;
  --brand-primary-light: #59c8c4 !important;
  --brand-primary-fill: #d9fffc !important;
  --text-on-brand-primary: #d9fffc !important;
  --background-primary: #36363e !important;
  --background-secondary: #2f2f37 !important;
  --background-secondary-alt: #32323a !important;
  --background-secondary-lighter: #2f2f37 !important;
  --background-tertiary: #292931 !important;
  --background-header-primary: #2f2f37 !important;
  --background-header-primary-hover: #41414b !important;
  --background-header-secondary: #32323a !important;
  --background-channel-header: #2f2f37 !important;
  --background-textarea: #292931 !important;
  --form-surface-background: #292931 !important;
  --text-primary: #edf3f4 !important;
  --text-chat: #edf3f4 !important;
  --text-secondary: #c8d2d6 !important;
  --text-primary-muted: #b5b5c2 !important;
  --text-chat-muted: #b5b5c2 !important;
  --text-tertiary: #b5b5c2 !important;
  --text-tertiary-muted: #a9a9b7 !important;
  --text-tertiary-secondary: #a9a9b7 !important;
  --text-link: #59c8c4 !important;
  --focus-primary: #59c8c4 !important;
  --border-color: #4c4c58 !important;
  --border-color-hover: #636371 !important;
  --border-color-focus: #59c8c4 !important;
  --background-modifier-hover: #41414b !important;
  --background-modifier-selected: #2a2316 !important;
  --background-modifier-accent: #636371 !important;
  --background-modifier-accent-focus: #59c8c4 !important;
  --surface-interactive-hover-bg: #41414b !important;
  --surface-interactive-selected-bg: #2a2316 !important;
  --surface-interactive-selected-color: #d5aa58 !important;
  --control-button-normal-text: #b5b5c2 !important;
  --control-button-hover-bg: #41414b !important;
  --control-button-hover-text: #edf3f4 !important;
  --control-button-active-bg: #2a2316 !important;
  --control-button-active-text: #d5aa58 !important;
  --text-selection: rgb(89 200 196 / 30%) !important;
}

/* Optional auth-card colours; retain the existing form layout. */
:root.theme-dark [data-flx="auth.flow.auth-card-container.div--3"] {
  background: #32323a !important;
}
:root.theme-dark [data-flx="auth.flow.auth-card-container.fluxer-wordmark"] {
  color: #e6c17b !important;
}

`;
